import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_RCE_TRANSLATIONS = 'rceTranslations/SET';

export const setRceTranslations = createAction(SET_RCE_TRANSLATIONS, translations => ({ translations }));
